import { httpGet } from './api.service';

const getPairingStats = async (fromDateTime?: string, toDateTime?: string): Promise<any> => {
  const params = new URLSearchParams();

  if (fromDateTime) params.append('fromDateTime', fromDateTime);
  if (toDateTime) params.append('toDateTime', toDateTime);

  const query = params.toString();
  const url = query ? `api/stats/pairing?${query}` : `api/stats/pairing`;

  return await httpGet(url);
};
const getSightingStats = async (fromDateTime?: string, toDateTime?: string): Promise<any> => {
  const params = new URLSearchParams();

  if (fromDateTime) params.append('fromDateTime', fromDateTime);
  if (toDateTime) params.append('toDateTime', toDateTime);

  const query = params.toString();
  const url = query ? `api/stats/sighting?${query}` : `api/stats/pairing`;

  return await httpGet(url);
};

const getDevicesStats = async () => {
  const res: any = await httpGet('api/stats/device');

  const deviceTypes = res?.data?.deviceTypes ?? [];
  const dateTimeRefreshed = res?.data?.dateTimeRefreshed;
  const dateTimeForNextRefresh = res?.data?.dateTimeForNextRefresh;

  return {
    status: res.status,
    data: deviceTypes.map((dt: any) => ({
      ...dt,
      dateTimeRefreshed,
      dateTimeForNextRefresh,
    })),
    totalCount: deviceTypes.length,
    dateTimeRefreshed,
    dateTimeForNextRefresh,
  };
};

export { getPairingStats, getSightingStats, getDevicesStats };
